function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShopping = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 1.145,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.655,9.486C4.82,9.486 4.149,10.158 4.149,10.992C4.149,11.826 4.82,12.498 5.655,12.498L8.923,12.498L12.707,32.355C12.845,33.064 13.466,33.578 14.187,33.578L34.766,33.578C35.6,33.578 36.271,32.907 36.271,32.072C36.271,31.238 35.6,30.567 34.766,30.567L15.436,30.567L14.865,27.555L34.753,27.555C35.65,27.555 36.441,26.959 36.686,26.093L40.073,14.047C40.431,12.768 39.471,11.494 38.141,11.494L11.803,11.494L11.652,10.71C11.514,10.001 10.893,9.486 10.172,9.486L5.655,9.486ZM15.191,41.609C16.854,41.609 18.202,40.26 18.202,38.597C18.202,36.935 16.854,35.586 15.191,35.586C13.528,35.586 12.18,36.935 12.18,38.597C12.18,40.26 13.528,41.609 15.191,41.609ZM36.271,38.597C36.271,36.935 34.923,35.586 33.26,35.586C31.597,35.586 30.248,36.935 30.248,38.597C30.248,40.26 31.597,41.609 33.26,41.609C34.923,41.609 36.271,40.26 36.271,38.597Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShopping);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shopping.b989afc9ba082fd4ef7f0e57a042035b.svg";